import React from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { message } from 'antd'
import FormComponent from './Form'
import { client } from '@utils/client'
import { useHistory } from 'react-router-dom'
import Modal from '@components/Modal'
import moment from 'moment'
const EditNameStore = (props) => {
  const { defaultValues, setModalEditOpen, modalEditOpen } = props
  const { t } = useLocalization()
  const history = useHistory()
  const handleSubmit = async (data) => {
    data.start = data.startToEnd[0].format('YYYY-MM-DD HH:mm:ss')
    data.end = data.startToEnd[1].format('YYYY-MM-DD HH:mm:ss')

    let shopId = data.id
    delete data.id // ลบ ID เนื่องจาก Put ใช้ส่งทั้ง Form Backend ไม่รับ
    delete data.startToEnd

    setModalEditOpen(false)
    try {
      await client.put(`/special-event/${shopId}`, data)
      message.success('สำเร็จ')
      history.push('/special-event')
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  defaultValues.startToEnd = [
    moment(defaultValues.start),
    moment(defaultValues.end),
  ]

  return (
    <>
      <Modal
        centered={true}
        title={t('rewards.specialEvent.listScreen.edit')}
        open={modalEditOpen}
        onCancel={() => setModalEditOpen(false)}
        maskClosable={false}
        footer={null}
      >
        <FormComponent
          handleSubmit={handleSubmit}
          doStatus="edit"
          defaultValues={defaultValues}
        />
      </Modal>
    </>
  )
}

EditNameStore.propTypes = {
  defaultValues: PropTypes.object,
  setModalEditOpen: PropTypes.func,
  modalEditOpen: PropTypes.bool,
}

export default EditNameStore
